export type DeviceType = 'mobile' | 'desktop'

export const getDeviceType = (): DeviceType => {
  return /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
}
